import Api, { handleData, handleError } from '../Api';
import request from '../request';

import { url } from './config';
import { EmailTemplate } from './types';

/** What a "pick some wording" dropdown needs — no audit columns. */
export type EmailTemplateOption = Pick<EmailTemplate, '_id' | 'name' | 'translations' | 'defaultLanguage'>;

class ExtendedApi extends Api<EmailTemplate> {
    /**
     * The template library for a send-time picker.
     *
     * Deliberately NOT `get()`: the plain list route is gated on
     * `setup.email_template:view` — an authoring permission almost no operational
     * role holds — and answers a denial with 401, which the response interceptor
     * turns into a forced logout. `/for-picker` needs only a session.
     */
    forPicker(): Promise<EmailTemplateOption[]> {
        return request
            .get<{ templates: EmailTemplateOption[] }>(`${url}/for-picker`)
            .then((res) => handleData(res).templates ?? [])
            .catch(handleError);
    }
}

const api = new ExtendedApi(url);

export default api;
